var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "297.333 73.333 533.332 533.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.4682)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 89.1175,
    x2: 71.8173,
    y1: 233.5573,
    y2: 193.1927,
    gradientTransform: "matrix(7.7071 0 0 -7.7071 -501.6811 1845.5039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37aee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e96c8"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 162.62,
    cy: 98.033,
    r: 76.889,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m117.731 97.367 51.778-21.333c5.111-2.222 22.444-9.333 22.444-9.333s8-3.111 7.333 4.444c-.222 3.111-2 14-3.778 25.778l-5.556 34.889s-.444 5.111-4.222 6c-3.778.889-10-3.111-11.111-4-.889-.667-16.667-10.667-22.444-15.556-1.555-1.333-3.333-4 .222-7.111 8-7.333 17.556-16.444 23.333-22.222 2.667-2.667 5.333-8.889-5.778-1.333L138.62 108.7s-3.555 2.222-10.222.222-14.445-4.667-14.445-4.667-5.333-3.333 3.778-6.888z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e8d51ab9e058c3e7e11c3ebacf3ba0d5.svg";
export { ForwardRef as ReactComponent };